import name from './name'

const selectSliceData = state => state[name]

const selectIsNewsletterPopoverOpen = state => selectSliceData(state).newsletterPopoverOpen
const selectIsSubscribedToNewsletter = state => selectSliceData(state).isSubscribed

export { selectIsNewsletterPopoverOpen, selectIsSubscribedToNewsletter }
